import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubSearchField]'})
export class SearchFieldDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
